import React from "react";

function Resume() {
   return (
      <div className="resume">
         <h2>Ambitious Full Stack Web Developer</h2>
         <p>
            I have a large spectrum of knowledge in both front-end and back-end
            languages and procedures. I received a Certificate in Full Stack Web
            Development through the Rutgers University bootcamp, and I'm seeking
            an opportunity as a Full Stack Developer to fully embrace my passion
            for web development in a professional work setting.
         </p>
         <h3>Technical Skills</h3>
         <ul>
            <li>
               Front-End: HTML5, JavaScript, CSS, AJAX, Handlebars, JSX, JQuery,
               Bootstrap, Foundation, SEO
            </li>
            <li>
               Back-End: MERN, MongoDB, Express.js, React.js, Node.js, REST,
               APIs, MySQL, NoSQL, GraphQL, OOP, ORM, Jest, TDD, MVC, User
               Authentication, Stripe, IndexDB
            </li>
         </ul>
         <h3>Skills</h3>
         <ul>
            <li>
               Flexible, quick learner, focused, dependable, self-starter, and
               detail-oriented
            </li>
            <li>Excellent verbal and written communication skills</li>
            <li>Strong problem solving skills</li>
            <li>
               Able to effectively self-manage while completing individual
               projects, as well as collaborate and contribute in a team setting
            </li>
            <li>Agile development methodology</li>
            <li>
               Experience with progressive web design, software development, and
               software testing
            </li>
            <li>Proficiency in Git and Microsoft Office</li>
         </ul>
         <h3>Work Experience</h3>
         <h4>Corporate Tax Coordinator</h4>
         <p>
            <em>
               First Citizen Bank - CIT Group Inc., Morristown, NJ (August 2018
               - Present)
            </em>
         </p>
         <ul>
            <li>
               Preparation of corporate state and local income and franchise tax
               returns
            </li>
            <li>
               Produce annual reports, estimates, and extensions for each entity
            </li>
            <li>
               Responsible for resolving state notices and processing refunds
            </li>
            <li>
               Involved with all necessary procedures to ensure subsidiaries
               receive proper tax clearance
            </li>
            <li>
               Work closely with legal team to advance the dissolution and
               withdrawal of entities in business activities ceased
            </li>
            <li>
               Mentorship and training of new tax coordinators to develop
               technical and leadership skills
            </li>
            <li>
               Working knowledge of requisite software and internal
               workflow/procedures
            </li>
         </ul>
         <h3>Education</h3>
         <ul>
            <li>
               Rutgers University - NJ (2022) - Full Stack Web Development
               Bootcamp Certificate
            </li>
            <li>
               Rutgers University - Newark, NJ (2021) - Bachelor of Arts,
               Economics, Minor in Psychology
            </li>
         </ul>
         <h3>Awards</h3>
         <p>
            <em>
               Rutgers University Coding Bootcamp (2022) - "Wiz with the
               Front-End Skills"
            </em>
         </p>
      </div>
   );
}

export default Resume;
